import { useTranslation } from 'react-i18next'

import { LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_KPIS_ORDER_KEY } from '../../../../constants/storage'
import { BirdviewTileRow } from '../../../DashboardBirdview'

import { OverviewKpiTile } from './OverviewKpiTile'
import {
  OVERVIEW_KPI_ROW_COLUMNS,
  QA_NAME_OVERVIEW_KPI_ROW,
} from './RentalPortalOverviewKpiRow.constants'
import {
  getOverviewKpis,
  getOverviewKpiTileId,
} from './RentalPortalOverviewKpiRow.utils'

function RentalPortalOverviewKpiRow({ isLoading, overview }) {
  const { t } = useTranslation()

  function renderTile(kpi) {
    return <OverviewKpiTile kpi={kpi} />
  }

  return (
    <BirdviewTileRow
      columns={OVERVIEW_KPI_ROW_COLUMNS}
      getItemId={getOverviewKpiTileId}
      items={getOverviewKpis({ isLoading, overview, t })}
      qaName={QA_NAME_OVERVIEW_KPI_ROW}
      renderItem={renderTile}
      storageKeyPrefix={LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_KPIS_ORDER_KEY}
    />
  )
}

export default RentalPortalOverviewKpiRow
